import React, { useEffect, useState } from "react";
import Select from "react-select";

export default (props) => {

  const [fieldValue, setFieldValue] = useState()

  useEffect(() => {
    setFieldValue(props.value)
  }, [props])

  return (
    <div>
      {props.withLabel && <label className="mb-3 block text-gray-500">{props.placeholder} {props.required ? <i className="star ">*</i> : ''}</label>}
      <Select
        onChange={props.onChange}
        placeholder="انتخاب کنید ..."
        isMulti={props.multi}
        id={props.name}
        name={props.name}
        isClearable={true}
        styles={
          {
             control: (provided) => ({
              ...provided,
              border: '1px solid #e0e0ef',
              padding: '0 10px',
              fontSize: '0.9rem',
            }),
            option: (provided) => ({
              ...provided,
              fontSize: '0.9rem',
            }),
            menu: (provided) => ({
              ...provided,
              zIndex: 1000000
            }),
            menuList: (provided) => ({
              ...provided,
              maxHeight: '150px',
              zIndex: 1000000
            }),
            valueContainer: (provided) => ({
              ...provided,
              lineHeight: '38px'
            })
          }
        }
        value={fieldValue}
        options={props.options}
      />
    </div>
  );
};
